export default "__VITE_ASSET__CyICH77a__"